import {Grid} from "@mui/material";
import {TextField} from "@material-ui/core";
import React from "react";

interface IData {
    label: string;
    value: string;
}

interface IDataFieldsProps {
    data: IData[];
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

const DataFields: React.FC<IDataFieldsProps> = ({
                                                    data,
                                                    xs = 12,
                                                    md = 4,
                                                    sm = 6
                                                }) => {
    return (<>
        {
            data.map(({label, value}, index) => (
                <Grid item key={index} xs={xs} md={md} sm={sm}>
                    <TextField
                        label={label}
                        value={value || "\u200B"}
                        InputProps={{
                            readOnly: true,
                        }}
                        variant="standard"
                        fullWidth
                        size="small"
                    />
                </Grid>
        ))
        }
    </>);
}

export default DataFields;

